import { render } from "./MassUpdatePolicyEmail.vue?vue&type=template&id=6fc5a660&scoped=true"
import script from "./MassUpdatePolicyEmail.vue?vue&type=script&lang=js"
export * from "./MassUpdatePolicyEmail.vue?vue&type=script&lang=js"

import "./MassUpdatePolicyEmail.vue?vue&type=style&index=0&id=6fc5a660&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc5a660"]])

export default __exports__